/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush on 7/9/20
 *
 */
import BaseObject from "@shared/BaseObject.js";
import {MenuAction} from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuAction";
import {isObject} from "@/utils/helpers";

function prepareOptions(options){
	if(typeof options === "string"){
		options = {title: options}
	}
	return options
}

export default class MenuItem extends BaseObject {

	action: MenuAction = null
	name: string = null
	description: string = null
	icon: string = null
	iconImage: string = null
	iconImageWidth: string = null
	isDivided: boolean = false
	showAsAction: boolean = false
	showAsActionText: boolean = false
	menuItemClass: string = null
	class: string = null
	style: string = null
	option = {}


	constructor(action: MenuAction, name: string, icon: string, isDivided: boolean, showAsAction: boolean) {
		super();
		let option
		if(isObject(name)){
			option = name
			name = null
		} else if(isObject(icon)){
			option = icon
			icon = null
		} else if (isObject(isDivided)) {
			option = isDivided
			isDivided = null
		} else {
			option = {name, icon, isDivided, showAsAction}
		}
		// console.log("MenuItem option = ", option)

		this.action = action;
		this.name = option.name || name;
		this.icon = option.icon || icon;
		this.isDivided = option.isDivided;
		this.showAsAction = option.showAsAction
		this.showAsActionText = option.showAsActionText || false
		this.description = option.description || ""
		this.class = option.class || ""
		this.style = option.style || ""
		this.iconImage = option.iconImage || null
		this.iconImageWidth = option.iconImageWidth || null
		if(this.showAsActionText){
			this.showAsAction = true
		}
		this.option = option
	}

	isDelete(){
		return this.action === MenuAction.MOVE_TO_TRASH
	}


	static createCopyItem(options){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.COPY, options.title || "Copy", "icon-docs", options)
	}
	static createDuplicateItem(options = {}){
		options = prepareOptions(options)
		return MenuItem.createCopyItem({...options, title: "Duplicate"})
	}

	static createDeleteItem(options = {}){
		options = prepareOptions(options)
		let menuItem = new MenuItem(options.action || MenuAction.DELETE, options.title || "Delete", options.icon || "icon-trash", options)
		menuItem.menuItemClass = "text-danger"
		return menuItem
	}
	static createArchiveItem(options = {}){
		options = prepareOptions(options)
		let menuItem = new MenuItem(MenuAction.ARCHIVE, options.title || "Archive", options.icon || "icon-file-archive", options)
		// menuItem.menuItemClass = "text-danger"
		return menuItem
	}
	static createUnarchiveItem(options = {}){
		options = prepareOptions(options)
		let menuItem = new MenuItem(MenuAction.UNARCHIVE, options.title || "Unarchive", options.icon || "icon-file-archive", options)
		// menuItem.menuItemClass = "text-danger"
		return menuItem
	}
	static createDeleteDividerItem(options = {}){
		options = prepareOptions(options)
		let menuItem = new MenuItem(MenuAction.DELETE, options.title || "Delete", options.icon || "icon-trash", {...options, isDivided: true})
		menuItem.menuItemClass = "text-danger"
		return menuItem
	}

	static createItem(options = {}, options2 = {}){
		options = prepareOptions(options)
		if(options2){
			options = Object.assign(options, options2)
		}
		return new MenuItem(options.action, options.title, options.icon, options)
	}
	static createShareItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.SHARE, options.title || "Share", options.icon || "icon-share", options)
	}
	static createUnshareItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.UNSHARE, options.title || "Unshare", options.icon || "icon-unlink", options)
	}
	static createLinkItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.LINK, options.title || "Link", options.icon || "icon-link", options)
	}
	static createUnlinkItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.UNLINK, options.title || "Unlink", options.icon || "icon-unlink", options)
	}

	static createOpenItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.OPEN, options.title || "Open", options.icon || "icon-folder-open-empty", options)
	}

	static createEditItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.EDIT, options.title || "Edit", options.icon || "icon-pencil", options)
	}

	static createRenameItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.RENAME, options.title || "Rename", options.icon || "icon-pencil", options)
	}

	static createMoveItem(options = {}){
		options = prepareOptions(options)
		if(!options.icon){
			options.iconImage = options.iconImage || "ic-move-to.svg"
		}
		return new MenuItem(MenuAction.MOVE, options.title || "Move to", options)
	}

	static createViewItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.VIEW, options.title || "View", options.icon || "icon-eye", options)
	}

	static createPrintItem(options = {}){
		options = prepareOptions(options)
		return new MenuItem(MenuAction.PRINT, options.title || "Print", options.icon || "icon-print", options)
	}
}
